import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Clinic } from 'app/shared/clinics/models/clinic.model';
import { HttpLoaderIndicatorService } from 'app/shared/layout/services/http-loader-indicator.service';
import { Identifier } from 'app/shared/storage/services/local-storage.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loadingService: HttpLoaderIndicatorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loadingService.setLoading(true);

    const modifiedRequest = this.getRequest(req);

    return next.handle(modifiedRequest).pipe(
      finalize(() => {
        this.removeRequest(req);
      })
    );
  }

  private removeRequest(req: HttpRequest<any>) {
    const index = this.requests.indexOf(req);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
    if (!this.requests.length) this.loadingService.setLoading(false);
  }

  private getRequest(req: HttpRequest<any>): HttpRequest<any> {
    const apiKey = localStorage.getItem('apiKey');
    if (!apiKey) {
      return req;
    }

    const skipInterceptor = req.headers.has('Skip-Interceptor');
    if (skipInterceptor) {
      return req.clone({ headers: req.headers.delete('Skip-Interceptor') });
    }

    return this.getRequestWithHeader(req);
  }

  private getRequestWithHeader(req: HttpRequest<any>): HttpRequest<any> {
    const token = req.headers.has('Member-Interceptor')
      ? localStorage.getItem('memberToken')
      : req.headers.has('Msal-Authorization')
        ? localStorage.getItem('msal.accToken')
        : localStorage.getItem('token');

    const apiKey = !req.headers.has('Msal-Authorization')
      ? localStorage.getItem('apiKey')
      : '372992e6-21c6-4a27-80c1-ff9688c91f3a';

    let headers = this.getDefaultHeader(token, apiKey);
    headers = this.setContentType(req.headers.get('Content-Type'), headers);

    return req.clone({ headers });
  }

  private getClinicId(): string {
    const value = localStorage.getItem('clinic');
    if (!value) {
      return '';
    }
    const currClinic: Clinic = JSON.parse(value);
    return currClinic ? currClinic.clinicId.toString() : '';
  }

  private getDefaultHeader(token: string | null, apiKey: string | null): HttpHeaders {
    const clinicGroupId = localStorage.getItem('clinicGroupId');
    const currentCulture = localStorage.getItem('culture');
    const franchiseId = localStorage.getItem(Identifier.TYPE_FRANCHISE_ID);

    let headers = new HttpHeaders({
      'X-Frame-Options': 'deny',
      ApiKey: apiKey as string,
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': currentCulture || 'en-CA',
    });

    const clinicId = this.getClinicId();

    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }
    if (clinicId) {
      headers = headers.append('ClinicId', clinicId);
    }
    if (clinicGroupId) {
      headers = headers.append('ClinicGroupId', clinicGroupId);
    }
    if (franchiseId) {
      headers = headers.append('ClinicGroupFranchiseId', franchiseId);
    }

    return headers;
  }

  private setContentType(contentType: string | null, headers: HttpHeaders): HttpHeaders {
    if (contentType === '') {
      return headers;
    }
    return contentType
      ? headers.append('Content-Type', contentType)
      : headers.append('Content-Type', 'application/json');
  }
}
